// Backend-Client. In Produktion same-origin (nginx proxyt /api), in der
// Entwicklung via REACT_APP_BACKEND_URL.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

export async function estimateDevice(name) {
  try {
    const r = await fetch(`${API}/estimate-device`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name }),
    });
    if (!r.ok) {
      let detail = "Anfrage fehlgeschlagen.";
      try {
        detail = (await r.json()).detail || detail;
      } catch (e) {
        /* ignore */
      }
      return { ok: false, reason: "http", message: detail };
    }
    return await r.json();
  } catch (e) {
    return { ok: false, reason: "network", message: "Keine Verbindung zum Server." };
  }
}

export async function getCustomDevices() {
  try {
    const r = await fetch(`${API}/custom-devices`);
    if (!r.ok) return [];
    const j = await r.json();
    return j.devices || [];
  } catch (e) {
    return [];
  }
}

export async function getPrice() {
  try {
    const r = await fetch(`${API}/price`);
    if (!r.ok) return null;
    const j = await r.json();
    return typeof j.pricePerKwh === "number" ? j : null;
  } catch (e) {
    return null;
  }
}

export async function getCustomDevice(slug) {
  try {
    const r = await fetch(`${API}/custom-devices/${slug}`);
    if (!r.ok) return null;
    return await r.json();
  } catch (e) {
    return null;
  }
}

// no-op page tracking placeholder (kept for App.js)
export function track(/* event, meta */) {}
